import { render, staticRenderFns } from "./PyramidChart.vue?vue&type=template&id=337a7d52&"
import script from "./PyramidChart.vue?vue&type=script&lang=js&"
export * from "./PyramidChart.vue?vue&type=script&lang=js&"
import style0 from "./PyramidChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports